// extracted by mini-css-extract-plugin
export default {"charts":"Chart_charts__CUT2q","card":"Chart_card__lA0at"};